import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function CardItem({ card, className = "" }) {
  return (
    <div className={`casino-result-cards-item${className ? ` ${className}` : ""}`}>
      <img src={getCardImage(card)} alt="" />
    </div>
  );
}

function Side({ name, isWinner, children }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4> {children}
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for baccarat / baccarat2 / pbaccarat:
 * Player cards [4 (l-rotate, if drawn), 2, 0], Banker [1, 3, 5 (r-rotate, if drawn)], trophy before the winner's hand;
 * rdesc "winner#winnerPair#perfect#either#bigSmall" (baccarat, pbaccarat) or "winner#winnerPair#score" (baccarat2).
 */
export default function BaccaratResultBody({ t1, gameType = "baccarat" }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const c = (i) => cards[i] || "1";
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const isB2 = gameType === "baccarat2";

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <Side name="Player" isWinner={win === "1"}>
            {c(4) !== "1" && <CardItem card={c(4)} className="l-rotate" />} <CardItem card={c(2)} />{" "}
            <CardItem card={c(0)} />
          </Side>{" "}
          <div className="casino-result-content-diveder" />{" "}
          <Side name="Banker" isWinner={win === "2"}>
            <CardItem card={c(1)} /> <CardItem card={c(3)} />{" "}
            {c(5) !== "1" && <CardItem card={c(5)} className="r-rotate" />}
          </Side>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Winner Pair</div> <div>{desc[1]}</div>
            </div>{" "}
            {isB2 ? (
              <div className="casino-result-desc-item">
                <div>Score</div> <div>{desc[2]}</div>
              </div>
            ) : (
              <>
                <div className="casino-result-desc-item">
                  <div>Perfect</div> <div>{desc[2]}</div>
                </div>{" "}
                <div className="casino-result-desc-item">
                  <div>Either</div> <div>{desc[3]}</div>
                </div>{" "}
                <div className="casino-result-desc-item">
                  <div>Big/Small</div> <div>{desc[4]}</div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
